/**
 * Insurance Agencies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
    AsyncManageAgencyListsComponent,
    AsyncCreateAgencyListComponent,
    AsyncModifyAgencyListComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
    <React.Fragment>
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
            <Route
                path={`${match.url}/view-all`}
                component={AsyncManageAgencyListsComponent}
            />
            <Route
                path={`${match.url}/create`}
                component={AsyncCreateAgencyListComponent}
            />
            <Route
                path={`${match.url}/modify`}
                component={AsyncModifyAgencyListComponent}
            />
        </Switch>
    </React.Fragment>
);

export default Forms;
